import { useEffect } from "react";
import "./termsandcondition.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      title: "1. Responsable del tratamiento y alcance.",
      body: (
        <>
          <p>
            La presente Política de Privacidad regula el tratamiento de los datos
            personales recabados a través del sitio web y de la Plataforma
            Ticketera ZOCO (en adelante, la “Plataforma”), propiedad de ZOCO
            S.A.S., con domicilio en Avenida Perón 2580, ciudad de Yerba Buena,
            provincia de Tucumán, República Argentina, en su carácter de
            responsable del tratamiento conforme a la Ley N.º 25.326 de
            Protección de los Datos Personales. La Plataforma permite a los
            usuarios seleccionar y adquirir entradas para eventos organizados por
            terceros independientes, actuando ZOCO exclusivamente como
            intermediario tecnológico y proveedor de servicios de cobro y emisión
            de entradas digitales.
          </p>
        </>
      ),
    },
    {
      title: "2. Datos personales recopilados.",
      body: (
        <>
          <p>
            ZOCO recopila únicamente los datos personales necesarios para
            permitir el registro en la Plataforma, la navegación, adquisición y
            la gestión de la compra de entradas, la emisión de comprobantes y el
            cumplimiento de obligaciones legales y contractuales. Dichos datos
            pueden incluir, según el caso, nombre y apellido, tipo y número de
            documento (DNI), correo electrónico, número de teléfono y demás datos
            de contacto, información vinculada a la operación realizada, eventos
            y entradas adquiridas, así como datos técnicos básicos del
            dispositivo utilizados para fines de seguridad, trazabilidad y
            correcto funcionamiento del servicio.
          </p>
          <p>
            Los datos vinculados a los medios de pago son procesados directamente
            por proveedores de servicios de cobro electrónicos certificados, sin
            que ZOCO almacene información sensible de tarjetas u otros
            instrumentos de pago.
          </p>
        </>
      ),
    },
    {
      title: "3. Finalidad del tratamiento.",
      body: (
        <>
          <p>
            Los datos personales recolectados son tratados con finalidades
            legítimas, explícitas y directamente relacionadas con el
            funcionamiento de la Plataforma. En particular, se utilizan para
            permitir el uso de la Plataforma, gestionar el proceso de compra de
            entradas y la emisión y envío de tickets digitales con código QR
            único, procesar pagos, enviar confirmaciones y notificaciones
            vinculadas a las operaciones realizadas, brindar soporte y atención
            al usuario, gestionar el derecho de arrepentimiento, atender consultas
            o reclamos, cumplir con obligaciones legales y regulatorias,
            garantizar la seguridad y trazabilidad de las operaciones, y realizar
            acciones de prevención de fraude y usos indebidos. Asimismo, los
            datos podrán ser utilizados para el análisis estadístico y la
            elaboración de métricas de uso de la Plataforma y, de manera
            compatible con las finalidades aquí descriptas, para acciones de
            comunicación, mejora de servicios y desarrollo de productos por parte
            de ZOCO y de otras sociedades que integran su grupo económico,
            incluyendo aquellas que prestan servicios de pagos u otros servicios
            tecnológicos relacionados, sin que ello implique un uso directo o
            independiente de la información ni su cesión a terceros ajenos al
            grupo. En ningún caso los datos personales serán utilizados con fines
            distintos de los aquí informados sin el consentimiento del titular,
            cuando este resulte legalmente exigible.
          </p>
        </>
      ),
    },
    {
      title: "4. Carácter obligatorio de la información.",
      body: (
        <>
          <p>
            El suministro de los datos personales requeridos por ZOCO constituye
            un requisito indispensable en la medida en que resulte necesario para
            la identificación del Consumidor, la celebración y ejecución de la
            relación contractual, así como para la adecuada prestación de los
            servicios ofrecidos a través de la Plataforma.
          </p>
          <p>
            La negativa a proporcionar dichos datos, así como su inexactitud,
            insuficiencia o falta de actualización, podrá imposibilitar la
            correcta prestación del servicio, incluyendo la imposibilidad de
            completar la operación, emitir las entradas correspondientes o acceder
            a determinadas funcionalidades de la Plataforma.
          </p>
        </>
      ),
    },
    {
      title: "5. Seguridad de la información y pagos.",
      body: (
        <>
          <p>
            Los pagos se procesan mediante plataformas de cobro electrónico que
            cumplen con estándares de seguridad PCI DSS y mecanismos de
            autenticación reforzada, tales como 3D Secure. Los datos se
            transmiten cifrados y tokenizados, reduciendo el riesgo de accesos no
            autorizados. ZOCO adopta medidas técnicas y organizativas razonables
            para proteger los datos personales contra pérdida, uso indebido,
            acceso no autorizado, alteración o divulgación indebida.
          </p>
        </>
      ),
    },
    {
      title: "6. Cesión y comunicación de datos.",
      body: (
        <>
          <p>
            Los datos personales podrán ser comunicados a los Organizadores del
            evento adquirido, exclusivamente en la medida necesaria para la
            correcta ejecución del contrato de compraventa celebrado entre el
            Comprador y el Organizador, en el marco del rol de ZOCO como
            intermediario tecnológico en la gestión y emisión de entradas
            digitales.
          </p>
          <p>
            Dicha comunicación tendrá como finalidad permitir la adecuada
            identificación del consumidor el día del evento, la validación del
            ticket emitido, el control de acceso, la gestión de acreditaciones,
            la atención de reclamos vinculados al espectáculo y el cumplimiento
            de obligaciones legales aplicables al Organizador.
          </p>
          <p>
            El Organizador actuará como responsable independiente del tratamiento
            respecto de los datos personales que le sean comunicados y se
            compromete a tratarlos de conformidad con la normativa vigente en
            materia de protección de datos personales y en términos compatibles
            con la presente Política de Privacidad. En caso de que el Organizador
            pretenda utilizar los datos para finalidades distintas a las aquí
            informadas, deberá obtener el consentimiento correspondiente del
            titular y brindarle la información exigida por la Ley N.º 25.326.
          </p>
          <p>
            Asimismo, ZOCO podrá compartir información con proveedores
            tecnológicos que actúan como encargados del tratamiento, tales como
            pasarelas de pago, herramientas de análisis y métricas de uso,
            servicios de email marketing y servicios de hosting o infraestructura,
            y con entidades de pago o autoridades competentes, cuando exista una
            obligación legal o un requerimiento válido. En todos los casos, dichos
            terceros acceden únicamente a la información estrictamente necesaria
            para la prestación de sus servicios, bajo acuerdos de confidencialidad
            y seguridad adecuados.
          </p>
          <p>ZOCO no comercializa ni cede datos personales con fines publicitarios.</p>
        </>
      ),
    },
    {
      title: "7. Almacenamiento y conservación de los datos.",
      body: (
        <>
          <p>
            Los datos personales tratados a través de la Plataforma son
            almacenados en entornos tecnológicos que cuentan con medidas de
            seguridad adecuadas para proteger la información. El acceso a la
            Plataforma y la transmisión de datos se realizan mediante protocolos
            seguros (HTTPS), con accesos restringidos exclusivamente a personal y
            sistemas autorizados, y mediante el uso de mecanismos de encriptación
            destinados a prevenir accesos no autorizados, pérdidas, alteraciones
            o divulgaciones indebidas. ZOCO adopta medidas técnicas y
            organizativas razonables acordes a la naturaleza de los datos tratados
            y a las mejores prácticas de la industria, con el objetivo de
            garantizar la confidencialidad, integridad y disponibilidad de la
            información.
          </p>
          <p>
            Los datos personales serán conservados durante el tiempo necesario
            para cumplir con las finalidades para las cuales fueron recabados o
            mientras subsistan obligaciones legales, contractuales o regulatorias.
            Cumplidos dichos plazos, la información será eliminada o anonimizada
            de forma segura.
          </p>
        </>
      ),
    },
    {
      title: "8. Derechos de los titulares de los datos.",
      body: (
        <>
          <p>
            El titular de los datos personales podrá ejercer los derechos de
            acceso, rectificación, actualización y supresión, conforme a la Ley
            N.º 25.326, mediante comunicación dirigida a info@zocoweb.com.ar
          </p>
        </>
      ),
    },
    {
      title: "9. Enlaces a sitios de terceros.",
      body: (
        <>
          <p>
            La Plataforma puede contener enlaces a sitios web de terceros,
            incluidos los de los Organizadores. ZOCO no es responsable por las
            prácticas de privacidad ni por los contenidos de dichos sitios, por
            lo que se recomienda al usuario revisar las políticas de privacidad
            correspondientes.
          </p>
        </>
      ),
    },
    {
      title: "10. Modificaciones.",
      body: (
        <>
          <p>
            ZOCO podrá modificar la presente Política de Privacidad en cualquier
            momento, publicando la versión actualizada en la Plataforma. Las
            modificaciones entrarán en vigencia desde su publicación.
          </p>
        </>
      ),
    },
    {
      title: "11. Contacto.",
      body: (
        <>
          <p>
            Para consultas, reclamos o el ejercicio de derechos relacionados con
            la presente Política de Privacidad, los usuarios podrán comunicarse
            con ZOCO a través del correo electrónico info@zocoweb.com.ar.
          </p>
        </>
      ),
    },
  ];

  const reservationSections = [
    {
      title: "1. Responsable del tratamiento y alcance.",
      body: (
        <>
          <p>
            La presente Política de Privacidad regula el tratamiento de los
            datos personales recabados a través del Servicio de Reserva de Mesas
            (en adelante, la "Plataforma"), administrado por ZOCO S.A.S., con
            domicilio en Avenida Perón 2580, Yerba Buena, Provincia de Tucumán,
            República Argentina, en su carácter de responsable del tratamiento,
            conforme a la Ley N.º 25.326 de Protección de los Datos Personales.
          </p>
          <p>
            La Plataforma permite a los usuarios realizar reservas en
            establecimientos gastronómicos, bares, restaurantes, clubes,
            espacios recreativos y demás comercios adheridos (en adelante, el
            "ORGANIZADOR"), actuando ZOCO exclusivamente como proveedor de la
            plataforma tecnológica y, cuando corresponda, como prestador de
            servicios de procesamiento de pagos.
          </p>
        </>
      ),
    },
    {
      title: "2. Datos personales recopilados.",
      body: (
        <>
          <p>
            ZOCO recopila únicamente los datos personales necesarios para
            gestionar las reservas realizadas a través de la Plataforma.
          </p>
          <p>Los datos podrán comprender:</p>
          <ul>
            <li>nombre y apellido;</li>
            <li>Documento Nacional de Identidad (DNI);</li>
            <li>correo electrónico;</li>
            <li>número de teléfono celular;</li>
            <li>domicilio.</li>
          </ul>
          <p>
            Cuando la reserva sea paga, podrán tratarse además los datos
            vinculados a la operación comercial y al procesamiento del pago.
          </p>
          <p>
            Los datos de tarjetas u otros instrumentos de pago son procesados
            por proveedores de servicios de pago y/o por ZOCO Servicios de
            Pagos conforme sus propios estándares de seguridad, sin que ZOCO
            almacene información sensible de dichos instrumentos.
          </p>
        </>
      ),
    },
    {
      title: "3. Finalidad del tratamiento.",
      body: (
        <>
          <p>Los datos personales serán tratados exclusivamente para:</p>
          <ul>
            <li>gestionar la reserva solicitada;</li>
            <li>
              identificar al usuario al momento de su ingreso al
              establecimiento;
            </li>
            <li>
              permitir la comunicación entre el usuario y el ORGANIZADOR
              respecto de la reserva;
            </li>
            <li>gestionar confirmaciones, modificaciones o cancelaciones;</li>
            <li>
              procesar pagos cuando el ORGANIZADOR hubiera habilitado dicha
              modalidad;
            </li>
            <li>brindar soporte sobre el funcionamiento de la Plataforma;</li>
            <li>prevenir fraudes, usos indebidos o incidentes de seguridad;</li>
            <li>cumplir obligaciones legales, regulatorias y contractuales.</li>
          </ul>
          <p>
            Asimismo, ZOCO podrá utilizar información estadística o anonimizada
            para el análisis, desarrollo y mejora de sus servicios
            tecnológicos.
          </p>
        </>
      ),
    },
    {
      title: "4. Carácter obligatorio de la información.",
      body: (
        <>
          <p>
            La provisión de los datos personales requeridos constituye un
            requisito necesario para gestionar la reserva solicitada.
          </p>
          <p>
            La negativa a suministrarlos, o el suministro de información
            incompleta, inexacta o desactualizada, podrá impedir la correcta
            utilización de la Plataforma o la confirmación de la reserva.
          </p>
        </>
      ),
    },
    {
      title: "5. Seguridad de la información.",
      body: (
        <>
          <p>
            ZOCO adopta medidas técnicas y organizativas razonables destinadas a
            proteger los datos personales contra pérdida, alteración, acceso no
            autorizado o tratamiento indebido.
          </p>
          <p>
            Las comunicaciones con la Plataforma utilizan protocolos seguros de
            transmisión de datos y mecanismos adecuados de protección de la
            información.
          </p>
          <p>
            No obstante, ningún sistema tecnológico puede garantizar un nivel
            absoluto de seguridad.
          </p>
        </>
      ),
    },
    {
      title: "6. Comunicación de datos personales.",
      body: (
        <>
          <p>
            Con la finalidad de permitir la correcta ejecución de la reserva,
            ZOCO comunicará los datos personales proporcionados por el usuario
            al ORGANIZADOR respecto del cual se haya efectuado la reserva.
          </p>
          <p>
            Dicha comunicación tendrá como única finalidad permitir al
            ORGANIZADOR:
          </p>
          <ul>
            <li>identificar al usuario;</li>
            <li>administrar la reserva;</li>
            <li>gestionar el ingreso al establecimiento;</li>
            <li>contactar al usuario respecto de la reserva;</li>
            <li>
              atender consultas o reclamos relacionados con el servicio
              contratado.
            </li>
          </ul>
          <p>
            Una vez recibidos los datos, el ORGANIZADOR actuará como
            responsable independiente del tratamiento respecto de la
            información comunicada.
          </p>
          <p>
            El ORGANIZADOR se obliga a tratar los datos personales únicamente
            para las finalidades precedentemente indicadas y conforme la
            normativa vigente en materia de protección de datos personales.
          </p>
          <p>
            En ningún caso podrá utilizar los datos para finalidades distintas,
            incluyendo acciones comerciales, promocionales, publicitarias,
            campañas de marketing, cesión a terceros o elaboración de bases de
            datos propias, salvo que cuente con una base legal suficiente y,
            cuando corresponda, con el consentimiento previo, libre, expreso e
            informado del titular de los datos.
          </p>
          <p>
            ZOCO no comercializa bases de datos personales ni autoriza su
            utilización para fines distintos de los previstos en la presente
            Política.
          </p>
        </>
      ),
    },
    {
      title: "7. Conservación y eliminación de los datos.",
      body: (
        <>
          <p>
            ZOCO conservará los datos personales únicamente durante el tiempo
            necesario para cumplir las finalidades descriptas en la presente
            Política, atender obligaciones legales, regulatorias o
            contractuales, resolver reclamos y ejercer o defender derechos.
          </p>
          <p>
            Cumplidas dichas finalidades, los datos serán eliminados, bloqueados
            o anonimizados, según corresponda.
          </p>
          <p>
            Del mismo modo, el ORGANIZADOR deberá eliminar los datos personales
            una vez cumplida la finalidad para la cual fueron comunicados, salvo
            que exista una obligación legal que justifique su conservación
            durante un plazo mayor.
          </p>
        </>
      ),
    },
    {
      title: "8. Derechos del titular de los datos.",
      body: (
        <>
          <p>
            El titular de los datos personales podrá ejercer en cualquier
            momento los derechos de acceso, rectificación, actualización,
            oposición y supresión previstos por la Ley N.º 25.326.
          </p>
          <p>
            Asimismo, podrá solicitar la eliminación de sus datos personales
            una vez finalizada la finalidad para la cual fueron recopilados,
            siempre que no exista una obligación legal que imponga su
            conservación.
          </p>
          <p>Las solicitudes podrán remitirse a info@zocoweb.com.ar.</p>
        </>
      ),
    },
    {
      title: "9. Enlaces a sitios de terceros.",
      body: (
        <>
          <p>
            La Plataforma podrá contener enlaces a sitios web del ORGANIZADOR u
            otros terceros.
          </p>
          <p>
            ZOCO no es responsable por las políticas de privacidad, contenidos
            o prácticas de dichos sitios, recomendándose al usuario consultar
            las políticas correspondientes antes de proporcionar información
            personal.
          </p>
        </>
      ),
    },
    {
      title: "10. Modificaciones.",
      body: (
        <>
          <p>
            ZOCO podrá modificar la presente Política de Privacidad cuando
            resulte necesario para adecuarla a cambios normativos,
            regulatorios, tecnológicos u operativos.
          </p>
          <p>
            La versión vigente será publicada en la Plataforma y entrará en
            vigor desde su publicación.
          </p>
        </>
      ),
    },
    {
      title: "11. Contacto.",
      body: (
        <>
          <p>
            Para consultas relacionadas con la presente Política de Privacidad
            o para ejercer los derechos previstos por la Ley N.º 25.326, los
            usuarios podrán comunicarse con ZOCO a través del correo
            electrónico info@zocoweb.com.ar.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="terms-page">
      <header className="terms-hero">
        <div className="terms-hero-inner pading150">
          <span className="terms-pill">Plataforma Web Ticketera ZOCO</span>
          <h1 className="terms-title">Política de Privacidad</h1>
          <p className="terms-subtitle">
            POLÍTICA DE PRIVACIDAD – PLATAFORMA WEB TICKETERA ZOCO
          </p>
          <p className="terms-subtitle">Última actualización: 06/04/2026</p>
          <p className="terms-subtitle">
            Incluye también la política de privacidad aplicable al servicio de
            reserva de mesas.
          </p>
        </div>
      </header>

      <div className="terms-content pading150">
        <div className="terms-stack">
          <div className="terms-card">
            {sections.map((section, index) => (
              <section
                key={section.title}
                className="terms-section"
                style={{ "--section-index": index }}
              >
                <h2>{section.title}</h2>
                {section.body}
              </section>
            ))}
          </div>

          <div className="terms-card terms-card-secondary">
            <div className="terms-module-head">
              <span className="terms-module-pill">Módulo de reservas</span>
              <h2>Política de Privacidad del Servicio de Reserva de Mesas</h2>
              <p>
                Aplicable a las reservas realizadas desde ZOCO para bares,
                restaurantes, clubes, espacios recreativos y demás comercios
                adheridos.
              </p>
              <p>Última actualización: 25/06/2026</p>
            </div>

            {reservationSections.map((section, index) => (
              <section
                key={section.title}
                className="terms-section"
                style={{ "--section-index": sections.length + index }}
              >
                <h2>{section.title}</h2>
                {section.body}
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
